import { customAlphabet } from "nanoid"

export class UidUtils {
  static generateUid(prefix: string = ""): string {
    const nanoid = customAlphabet("1234567890ABCDEFGHIJKLMNOPQRSTUWXZ", 10)
    return prefix + nanoid()
  }
}
